import { useSelector } from 'react-redux'
import { Company, CompanyAttributes } from '../../../types/Company'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import MoneyspaceUsersView from './MoneyspaceUsersView'
import { Moneyspace } from '../../../types/Moneyspace'
import Label from '../../atoms/display/Label'
import Button from '../../atoms/inputs/Button'
import { useMoneyspaceClientEditDialog } from '../../../hooks/useDialog'
import ClientEvaluationRatingView from '../client/ClientEvaluationRatingView'
import { SessionSelectors } from '../../../store/session/selectors'

type MoneyspaceClientViewProps = {
  client: CompanyAttributes | null
  company?: Company
  moneyspace: Moneyspace
  editableMember: boolean
}

export default function MoneyspaceClientView({
  client,
  company,
  moneyspace,
  editableMember,
}: MoneyspaceClientViewProps) {
  const companyId = useSelector(SessionSelectors.companyId)
  const moneyspaceClientEditDialog = useMoneyspaceClientEditDialog()
  if (company) {
    return (
      <FlexColumn space={0}>
        <Label text={company.name} />
        <MoneyspaceUsersView moneyspace={moneyspace} targetCompanyId={company.id} editable={editableMember} />
        {company.id !== companyId && <ClientEvaluationRatingView companyId={company.id} />}
      </FlexColumn>
    )
  }
  return (
    <FlexRow align="center">
      {client && <Label text={client.name} />}
      <Button variant="text" onClick={() => moneyspaceClientEditDialog.open(moneyspace)}>
        取引先情報を設定
      </Button>
    </FlexRow>
  )
}
